import { REGION_WORLD } from '../../state/modules/app/geoSelector/actions';

export const TYPE_STANDARD = 'location';
export const TYPE_RADIOMETRO = 'radioMetro';
export const TYPE_DMA = 'dma';
export const TYPE_UNRATED = 'isUnrated';
export const MARKET_ID = 'market';
export const UNRATED_ID = 'unrated';

 
export const SELECTION_TYPES = {
  [TYPE_RADIOMETRO]: 'Metro',
  [TYPE_DMA]: 'DMA',
  [TYPE_STANDARD]: 'Other'
};

export const SEARCH_PLACEHOLDERTEXT = {
  [TYPE_STANDARD]: 'Search by country, state/region, county, or city',
  [TYPE_RADIOMETRO]: 'Search by Metro, county, or city',
  [TYPE_DMA]: 'Search by DMA, county, or city'
}

export const SELECTION_LOADINGSTATUS = {
  [TYPE_STANDARD]: 'loadingStatus',
  [TYPE_RADIOMETRO]: 'radioMetroLoadingStatus',
  [TYPE_DMA]: 'dmaLoadingStatus'
};

export const TYPE_ANNOTATION = {
  radioMetro: 'Metro',
  dma: 'DMA',
  country: 'Country',
  state: 'State',
  county: 'County',
  city: 'City'
}

// Match aggregate table
export const GEO_LOCATION_TYPE = {
  COUNTRY: 'Country',
  STATE: 'State',
  COUNTY: 'County',
  CITY: 'City',
  METRO: 'Metro',
  DMA: 'DMA'
}

export const UNRATED_LABEL = {
  id: UNRATED_ID,
  name: 'Unrated Market',
  isCategory: true
}

export const MARKET_LABEL = {
  id: MARKET_ID,
  isCategory: true
}

export const ALL_LABEL = {
  id: REGION_WORLD,
  name: 'All',
  parentId: REGION_WORLD
}
